import React, { useEffect, useState } from 'react';
import { dispatchService } from '../../services/central-api/dispatch';
import FilterDropdown from '../Filter/components/FilterDropdown';
import { useAuth } from '../../context/Auth';
import { translate } from '../../services/translate';

type SetStateCallback<S> = ((prevState: S) => S);

interface Props {
    value: number[];
    setValue: React.Dispatch<SetStateCallback<number[]>>;
    zIndex?: number;
    disabled?: boolean;
    labelFontSize?: number;
    actingBodyId: number;
    finishReasonCategoryId?: number;
    showTooltip?: boolean;
    tooltipText?: string;
}

export default function FinishReasonSubCategoryDropdown({
    value, setValue, zIndex, disabled, labelFontSize, actingBodyId, finishReasonCategoryId, showTooltip, tooltipText
}: Props) {
    const { user: authenticatedUser } = useAuth();
    const [subCategories, setSubCategories] = useState<DropdownResource[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);

    async function loadSubCategories() {
        if (!finishReasonCategoryId) {
            setSubCategories([]);
            return;
        }
        setIsLoading(true);
        try {
            const result = await dispatchService.getSimplifiedSubCategoriesFinishReason(finishReasonCategoryId);
            setSubCategories(result);
        } catch (err) {
            console.error(err);
        } finally {
            setIsLoading(false);
        }
    }


    useEffect(() => {
        if (!authenticatedUser) {
            return;
        }
        loadSubCategories();
    }, [finishReasonCategoryId, actingBodyId, authenticatedUser]);

    return (
        <FilterDropdown
            label={translate('finishReasonSubCategory')}
            items={subCategories.map(sc => ({
                label: sc.name,
                value: sc.id
            }))}
            multiple={true}
            mode="BADGE"
            setValue={setValue}
            value={value}
            zIndex={zIndex}
            disabled={disabled}
            labelFontSize={labelFontSize}
            showTooltip={showTooltip}
            tooltipText={tooltipText}
            loading={isLoading}
            hideLabel
        />
    );
}
